(() => {
  const syncDeliveryBadgeAvailability = () => {
    const productBadges = document.querySelectorAll("[data-fn-delivery-today][data-fn-delivery-context='product']");
    if (!productBadges.length) return;

    const inventoryStatus = document.querySelector(".js-inventory")?.getAttribute("data-status");
    const selectedVariantId = document.querySelector("#select-master")?.value;
    const selectedVariant = window.theme?.product?.variants?.find((variant) => String(variant.id) === String(selectedVariantId));
    const isSoldOut = inventoryStatus === "out-stock" || selectedVariant?.available === false;

    productBadges.forEach((badge) => {
      if (isSoldOut) {
        badge.dataset.fnDeliveryAvailable = "false";
        badge.classList.add("d-none");
        badge.style.display = "none";
        badge.setAttribute("aria-hidden", "true");
      } else {
        badge.dataset.fnDeliveryAvailable = "true";
        badge.style.removeProperty("display");
      }
    });
  };

  document.addEventListener("DOMContentLoaded", syncDeliveryBadgeAvailability);
  document.addEventListener("change", () => setTimeout(syncDeliveryBadgeAvailability, 0), true);
  document.addEventListener("click", () => setTimeout(syncDeliveryBadgeAvailability, 0), true);
  setInterval(syncDeliveryBadgeAvailability, 500);
})();
